import { useUserPackages } from '../queries/useUserPackages'

export const useUserShippedPackages = () => {
  return useUserPackages(packages => packages?.filter(pkg => pkg.isShipped))
}
